var _defs, _rect, _path, _path2, _path3, _rect2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 2 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .line{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n      .plate{fill:var(--icon-accent,#f5a623);opacity:.14;}\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "line",
    x: 4,
    y: 3.5,
    width: 16,
    height: 17,
    rx: 2,
    ry: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M7 8.5h10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M12 8.5v3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M11.5 11.5l0.5 0.75l0.5-0.75"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "plate",
    x: 6.5,
    y: 15.5,
    width: 11,
    height: 2.5,
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M7 16.5h10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.ce78e66421fec6ed786fe152c162593f.svg";
export { ForwardRef as ReactComponent };